module.exports = __webpack_public_path__ + "static/media/GAMKONORA_ch2_20210921132649_T.be531754.jpg";